import MinusIcon from '@mui/icons-material/Remove';
import { Box, Collapse, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import Link from '../Link/Link';
import {
  Background,
  Heading,
  IconsWrapper,
  TopMinusIcon,
} from './Accordion.style';

const Accordion = ({ onClick, active, data }) => {
  const { headline, text, link, openInNewTab } = data;

  return (
    <Background active={active} onClick={onClick} data-test-subject="step">
      <Stack direction="row" justifyContent="space-between" spacing={1}>
        <Heading
          data-test-subject="headline"
          variant="h4Redesign"
          component="h3"
          color="primary"
          active={active}>
          {headline}
        </Heading>
        <IconsWrapper>
          <MinusIcon color="primary" fontSize="inherit" />
          <TopMinusIcon color="primary" active={active} fontSize="inherit" />
        </IconsWrapper>
      </Stack>
      <Collapse in={active}>
        {text && (
          <Typography
            data-test-subject="text"
            component="p"
            variant="body1Redesign"
            mt={1.5}
            color="text.secondary">
            {text}
          </Typography>
        )}
        {link && (
          <Box mt={1.5}>
            <Link
              dataTestSubject="link"
              link={link}
              openInNewTab={openInNewTab}
            />
          </Box>
        )}
      </Collapse>
    </Background>
  );
};

Accordion.propTypes = {
  data: PropTypes.shape(
    {
      headline: PropTypes.string.isRequired,
      text: PropTypes.string,
      link: PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }.isRequired
  ),
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};

export default Accordion;
